import Rules from '../components/Rules/Rules';

const RulesPage = () => <Rules />;

export default RulesPage;
